import { Suspense, lazy, type ReactNode } from "react"
import { QueryClientProvider } from "@tanstack/react-query"

import { queryClient } from "@/api/query-client"
import { ThemeProvider } from "@/theme/theme-provider"
import { SessionProvider } from "@/auth/session"

// The toast layer renders nothing until something is toasted, so it has no
// business in the shell chunk on a connection the PDD designs around (§2.4).
const Toaster = lazy(async () => ({ default: (await import("@/components/ui/sonner")).Toaster }))

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ThemeProvider>
          {children}
          <Suspense fallback={null}>
            <Toaster />
          </Suspense>
        </ThemeProvider>
      </SessionProvider>
    </QueryClientProvider>
  )
}
